import { z } from 'zod';
import type { TransactionTargetInfo } from '@/application/utils/types';

export const transactionDetailSchema = z.object({
  txnName: z.string({ required_error: 'Transaction Name' }).min(1, 'Transaction Name'),
  wasId: z.string({ required_error: 'WAS ID' }).min(1, 'WAS ID'),
  tid: z.string({ required_error: 'Transaction ID' }).min(1, 'Transaction ID'),
  wasCollectTime: z.string({ required_error: 'WAS Collect Time' }).min(1, 'WAS Collect Time'),
});

export type TransactionDetailSchema = z.infer<typeof transactionDetailSchema>;

export type TransactionDetailAddition = Omit<TransactionTargetInfo, 'endTime'>;
